import { SxProps } from "@mui/material";
import { useGetOne } from "react-admin";
import { grants } from "../backoffice.access_control";
import { DrivingSchool, DrivingSchoolLabel } from "../providers/drivingSchoolsProvider";
import { Student } from "../providers/studentsProvider";
import { Row } from "./Row";
import { Label } from "./Label";

export function StudentLabels(
  props: ({ studentId: string; student?: never } | { studentId?: never; student: Student }) & { size?: "small" },
) {
  const { studentId, size } = props;
  const { data } = useGetOne<Student>("students", { id: studentId! }, { enabled: !!studentId });
  const student = props.student ?? data;
  const drivingSchoolId = student?.drivingSchoolId;
  const { data: drivingSchool } = useGetOne<DrivingSchool>(
    "drivingSchools",
    { id: drivingSchoolId! },
    { enabled: !!drivingSchoolId },
  );
  const displayedLabels: DrivingSchoolLabel[] = (student?.assignedLabels ?? []).reduce(
    (acc, id) => (drivingSchool?.labels?.[id] ? [...acc, drivingSchool.labels[id]] : acc),
    [] as DrivingSchoolLabel[],
  );

  if (student && grants.has("editHubspotContactId") && !student.hubspotContactId) {
    displayedLabels.push({
      id: "missing-hubspot-contact-id",
      name: "Hubspot ID fehlt",
      description: "Der Fahrschüler hat keine HubSpot Contact ID.",
      color: "redUltraLight",
    });
  }

  if (displayedLabels.length === 0) {
    return null;
  }

  return (
    <Row gap={1} pb={1} sx={size === "small" ? _smallStyle : _normalStyle}>
      {displayedLabels.map((label) => (
        <Label key={label.id} label={label} />
      ))}
    </Row>
  );
}

const _normalStyle: SxProps = {
  flexWrap: "wrap",
};

const _smallStyle: SxProps = {
  flexWrap: "wrap",
  p: 0,
  "& .MuiChip-root": {
    fontSize: "9px",
    height: "18px",
    "& .MuiChip-label": {
      px: "6px",
    },
  },
};
